import styled from 'styled-components';
import COLORS from '../../common/styles/color-pallete';

export const PublicTimeLineContainer = styled.div`
  margin-bottom: ${(props) => props.marginBottom}px;
  margin-top: ${(props) => props.marginTop}px;
  height: 2px;
  width: 80%;
  background-color: ${COLORS.lightGrey};
  .timeline-progress {
    width: ${(props) => props.width}%;
    height: 100%;
    background-color: ${COLORS.brandPrimary};
    border-top-right-radius: 2px;
    border-bottom-right-radius: 2px;
    transition: all 2s ease;
  }
  .timeline-items {
    margin-left: 0;
    margin-right: 0;
    display: flex;
    margin-top: -4px;
    justify-content: space-between;
  }
  .timeline-item {
    position: relative;
  }
  .timeline-item::before {
    content: '';
    width: 5px;
    height: 5px;
    background-color: ${COLORS.textLightGrey};
    display: block;
    border-radius: 100%;
  }
  .timeline-content {
    font-size: 12px;
    position: absolute;
    top: 10px;
    left: 50%;
    background-color: transparent;
    width: 100px;
    padding: 10px;
    text-align: center;
    transform: translateX(-50%);
  }
  .timeline-item.active::before {
    background-color: ${COLORS.brandPrimary};
    height: 10px;
    width: 10px;
    margin-top: -2px;
  }
  .timeline-item.active .timeline-content {
    color: ${COLORS.brandPrimary};
  }

  .timeline-item.active .timeline-content::before {
    background-color: green;
  }
`;
